import { Component, computed, inject } from '@angular/core'
import { UpperCasePipe } from '@angular/common'
import { toSignal } from '@angular/core/rxjs-interop'
import { catchError, of } from 'rxjs'
import { ConfigService, Environment } from '../../services/config.service'

type Severity = 'none' | 'test' | 'real-money'

// dev/staging/sandbox are self-evidently test environments; prod is self-evidently real
// (real domain, real branding) so a banner there would just alarm genuine customers. preprod
// is the one environment that's easy to mistake for a sandbox while actually moving real funds.
function severityFor(environment: Environment | undefined): Severity {
  switch (environment) {
    case 'dev':
    case 'staging':
    case 'sandbox':
      return 'test'
    case 'preprod':
      return 'real-money'
    default:
      return 'none'
  }
}

@Component({
  selector: 'app-environment-banner',
  imports: [UpperCasePipe],
  templateUrl: './environment-banner.component.html',
})
export class EnvironmentBannerComponent {
  private configService = inject(ConfigService)

  private config = toSignal(this.configService.getConfig().pipe(catchError(() => of(null))))

  environment = computed(() => this.config()?.environment)
  severity = computed(() => severityFor(this.environment()))
}
